export const extractNumberFromString = (str: string) => {
  const match = str.match(/\d+/)
  return match ? parseInt(match[0]) : null
}
